module.exports = __webpack_public_path__ + "media/Teil 3.3133b84b.webm";